'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { DELAY_BEFORE_TRIGGER_MS, EXIT_INTENT_SIGNAL, MOUSE_SENSITIVITY_PX } from '../constants';
import { type ExitIntentTrigger, hasExitIntentBeenShown } from '../utils/session';
export function useDesktopMouseLeaveSignal(triggerRef, hasFired) {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] !== hasFired || $[1] !== triggerRef) {
    t0 = () => {
      if (hasFired || hasExitIntentBeenShown()) {
        return;
      }
      let delayTimeoutId;
      const fire = () => {
        triggerRef.current?.(EXIT_INTENT_SIGNAL.desktopMouseLeave);
      };
      const onMouseLeave = event => {
        if (event.clientY > MOUSE_SENSITIVITY_PX) {
          return;
        }
        delayTimeoutId = setTimeout(fire, DELAY_BEFORE_TRIGGER_MS);
      };
      const onMouseEnter = () => {
        clearTimeout(delayTimeoutId);
      };
      const onKeyDown = event_0 => {
        if (!(event_0.metaKey || event_0.ctrlKey) || event_0.key.toLowerCase() !== "l") {
          return;
        }
        delayTimeoutId = setTimeout(fire, DELAY_BEFORE_TRIGGER_MS);
      };
      const html = document.documentElement;
      html.addEventListener("mouseleave", onMouseLeave);
      html.addEventListener("mouseenter", onMouseEnter);
      html.addEventListener("keydown", onKeyDown);
      return () => {
        clearTimeout(delayTimeoutId);
        html.removeEventListener("mouseleave", onMouseLeave);
        html.removeEventListener("mouseenter", onMouseEnter);
        html.removeEventListener("keydown", onKeyDown);
      };
    };
    t1 = [triggerRef, hasFired];
    $[0] = hasFired;
    $[1] = triggerRef;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
}